export default "__VITE_ASSET__DDK$NSWo__"